/**
 *  标签输入框组件
 *  zhang.yingyu 
 *  2018-4-24
 */
"use strict";
angular.module("myTagsInputModule", []).
directive("myTagsInput", ["$validation","modalDialog" ,function($validation,modalDialog) {
    return {
        restrict: "A",
        replace: true,
        templateUrl: "./planningCenter/eventAnalysis/directive/myTagsInput/myTagsInput_tpl.html",
        scope: {
            tagsArray: "=ngModel"
        },
        link: function(scope, $elem, $attrs) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    curId: parseInt(Math.random() * 10000)
                };
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {}
            /**
             * [insert description] 加入标签
             * @return {[type]} [description]
             */
            scope.insert = function() {
                var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
                if(regEn.test(scope.status.curInput)) {
                    modalDialog.alertType('不能输入特殊字符', '', 'error', false, function() {});
                    scope.status.curInput='';
                    return;
                }
                if (!scope.isRepeat(scope.status.curInput) && scope.status.curInput !== "") {
                    scope.tagsArray.push(scope.status.curInput.trim());
                    scope.status.curInput = "";
                }
            };
            /**
             * [isRepeat description] 是否重复
             * @return {Boolean} [description]
             */
            scope.isRepeat = function(words) {
                return scope.tagsArray.indexOf(words) >= 0 ? true : false;
            };
            /**
             * [pressInsert description] 按键插入
             * @param {evt} [$event] [description] 事件
             * @return {[type]} [description]
             */
            scope.pressInsert = function($event) {
                if ($event.keyCode === 32 || $event.keyCode === 13) {
                    scope.insert();
                }
            };
            scope.delKeywordTip=function(index){
                scope.tagsArray.splice(index, 1);
            }
        }
    };
}]);